import "./Realisations.css";
import img1 from "../../assets/nettoyage-chantier.jpg";
import img2 from "../../assets/nettoyage-cabine.jpg";
import img3 from "../../assets/nettoyage-maison.jpg";
import img4 from "../../assets/nettoyage-sol.jpg";

export default function Realisations() {
  const images = [img1, img2, img3, img4];

  return (
    <section id="realisations" className="realisations container">
      <h2 className="section-title">Nos <span className="yellow">réalisations</span></h2>
      
      <div className="realisations-grid">
        {images.map((img, i) => (
          <div className="realisations-card" key={i} style={{ backgroundImage: `url(${img})` }}></div>
        ))}
      </div>
    </section>
  );
}
